import { Table } from '../../Table';
import useRankingTable from '../../../hooks/useRankingTable';
import { StyledTables } from '../style';
import { TableComponentProps } from '../types';

const columnLables = {
  ranking: {
    name: 'Ranking',
    isStatic: false
  },
  instrument_name: {
    name: 'Instrument Name',
    isStatic: false
  },

  sub_asset_type: {
    name: 'Sub-Asset Type',
    isStatic: false
  },
  instructions: {
    isStatic: true,
    name: 'Instructions',
    description: 'Either an ISIN or an All code should be entered, but not both'
  },
  isin: {
    name: 'ISIN',
    isStatic: false
  },
  all: {
    isStatic: true,
    name: 'All',
    description: 'Fields below'
  },
  exchange_code: {
    name: 'Exchange code',
    isStatic: false
  },
  product_code: {
    name: 'Product code',
    isStatic: false
  },
  derivative_type: {
    name: 'Derivative Type',
    isStatic: false
  },
  put_call: {
    name: 'Put/Call',
    isStatic: false
  },
  expiry_date: {
    name: 'Expiry Date',
    isStatic: false
  },
  strike_price: {
    name: 'Strike Price',
    isStatic: false
  },
  other: {
    isStatic: true,
    name: 'Other',
    description: 'Fields below'
  },
  position_value: {
    name: 'Position Value',
    isStatic: false
  },
  position_type: {
    name: 'Position Type',
    isStatic: false
  },
  short_position_hedging_rate: {
    name: 'Hedging % for Short Position',
    isStatic: false
  },
  instrument_code_type: {
    name: 'Instrument code type of the five main instruments in which the AIF is trading',
    isStatic: false,
    withoutLetter: true
  }
};

export function MainInstruments({
  onChangeFund,
  funds,
  currentDataKey,
  schema,
  isStaticTemplate,
  isMultiFunds
}: TableComponentProps) {
  const { columns, onChange, tables } = useRankingTable({
    data: funds[currentDataKey]?.fund_data?.MAIN_INSTRUMENTS,
    onChangeFund,
    schema: schema.MAIN_INSTRUMENTS,
    isStaticTemplate,
    requiredFields: funds[currentDataKey]?.required_tables?.MAIN_INSTRUMENTS?.field_names || [],
    isMultiFunds,
    funds,
    columnLables,
    tableName: 'MAIN_INSTRUMENTS',
    order: 42
  });

  return (
    <StyledTables id="fca-reporttables-main-instruments-group">
      {tables.map((rows, index) => (
        <div
          className={(isMultiFunds && 'table-wrapper') || undefined}
          id={`fca-reporttables-main-instruments-item-${index + 1}`}
          key={index + 'MAIN_INSTRUMENTS'}
        >
          <Table
            id={`fca-reporttables-main-instruments-table-${index + 1}`}
            stickyLeftColumns={isMultiFunds && Object.keys(funds).length > 2 ? 3 : null}
            handleChanges={onChange}
            columns={columns}
            rows={rows}
            stickyTopRows={isMultiFunds ? 1 : null}
          />
        </div>
      ))}
    </StyledTables>
  );
}
